module.exports = __webpack_public_path__ + "static/media/filter_big.576a17d9.svg";